import React, { useState, createContext, useContext } from "react";
import { Address, defaultDeliveryAddress } from "../types/LocationTypes";
import { CachedGroceryCartItem, DeliverySchedule } from "../types/GroceryTypes";

export const GroceryContext = createContext<any | undefined>(undefined);

export const useGroceryCtx = () => useContext(GroceryContext);

export const GroceryProvider: React.FC = ({ children }) => {
  const [selectedDeliverySchedule, setSelectedDeliverySchedule] = useState<
    DeliverySchedule
  >({
    date: "",
    window: "",
  });
  const [selectedGroceryCategoryIds, setSelectedGroceryCategoryIds] = useState<
    number[]
  >();
  const [isDeliveryScheduled, setIsDeliveryScheduled] = useState<boolean>(
    false
  );
  const [deliveryAddress, setDeliveryAddress] = useState<Address>(
    defaultDeliveryAddress
  );
  const [cachedGroceryCartItems, setCachedGroceryCartItems] = useState<
    CachedGroceryCartItem[]
  >([]);
  const [deliveryNote, setdeliveryNote] = useState<string>("");

  return (
    <GroceryContext.Provider
      value={{
        selectedGroceryCategoryIdsCtx: [
          selectedGroceryCategoryIds,
          setSelectedGroceryCategoryIds,
        ],
        isDeliveryScheduledCtx: [isDeliveryScheduled, setIsDeliveryScheduled],
        deliveryAddressCtx: [deliveryAddress, setDeliveryAddress],
        cachedGroceryCartItemsCtx: [
          cachedGroceryCartItems,
          setCachedGroceryCartItems,
        ],
        deliveryNoteCtx: [deliveryNote, setdeliveryNote],
        selectedDeliveryScheduleCtx: [
          selectedDeliverySchedule,
          setSelectedDeliverySchedule,
        ],
      }}
    >
      {children}
    </GroceryContext.Provider>
  );
};
